import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Button, Col, Row, Typography } from 'antd';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { DATA_MINIMA_DASHBOARD } from '../../../config/params';
import { Styles } from './styles';

export default function VerMais(props) {
  const {
    tipo,
    setDate,
    setVerMais,
    setOrder,
    dataAlterada,
    setDataAlterada,
    tab,
  } = props;

  const [disabledPassado, setDisabledPassado] = useState(false);
  const [disabledFuturo, setDisabledFuturo] = useState(false);

  useEffect(() => {
    const disabledVerMais = () => {
      if (tab === 'variacaoFrete') return;

      let disabledVMPassado = false;
      let disabledVMFuturo = false;
      const dtDefault =
        tab === 'variacaoFrete'
          ? moment().startOf('year')
          : moment(DATA_MINIMA_DASHBOARD, 'YYYY-MM-DD');

      switch (tipo) {
        case 'DAILY':
          disabledVMPassado =
            dtDefault.startOf('days') >=
            moment(dataAlterada?.dataInicial, 'YYYY-MM-DD').startOf('days');

          disabledVMFuturo =
            moment(dataAlterada?.dataFinal, 'YYYY-MM-DD')
              .endOf('days')
              .format() >
            moment()
              .endOf('days')
              .format('YYYY-MM-DD');
          break;
        case 'WEEKLY':
          disabledVMPassado =
            dtDefault.startOf('isoWeeks') >=
            moment(dataAlterada?.dataInicial, 'YYYY-MM-DD').startOf('isoWeeks');

          disabledVMFuturo =
            moment(dataAlterada?.dataFinal, 'YYYY-MM-DD')
              .startOf('isoWeeks')
              .add(1, 'isoWeeks') > moment().endOf('isoWeeks');
          break;
        case 'MONTHLY':
          disabledVMPassado =
            dtDefault.startOf('months') >=
            moment(dataAlterada?.dataInicial, 'YYYY-MM-DD').startOf('months');

          disabledVMFuturo =
            moment(dataAlterada?.dataFinal, 'YYYY-MM-DD').add(1, 'months') >
            moment().endOf('months');
          break;
        default:
          disabledVMPassado = true;
          disabledVMFuturo = true;
          break;
      }
      setDisabledPassado(disabledVMPassado);
      setDisabledFuturo(disabledVMFuturo);
    };
    disabledVerMais();
  }, [tipo, dataAlterada, tab]);

  /**
   * @description Pega data
   * @param {Date} data
   * @param {days|isoWeeks|months} tipoData
   * @param {init|end} time
   * @param {Number} value
   */
  const factoryData = (data, tipoData, time, value) => {
    let dt = moment(data, 'YYYY-MM-DD');
    dt = time === 'init' ? dt.startOf(tipoData) : dt.endOf(tipoData);

    return dt.add(value, tipoData).format();
  };

  /**
   * utilizar `setDataAlterada` como um estado que armazena os periodos originais,
   *  de maneira que seja possivel navegar entre os `ver mais`.
   */
  const aoVerMais = order => {
    let dataFiltro = {};
    let dtAlterada = {};
    if (order === 'past') {
      switch (tipo) {
        case 'DAILY':
          dataFiltro = {
            dataInicial: factoryData(
              dataAlterada?.dataInicial,
              'days',
              'init',
              -1
            ),
            dataFinal: factoryData(
              dataAlterada?.dataInicial,
              'days',
              'end',
              -1
            ),
          };

          dtAlterada = {
            dataInicial: factoryData(
              dataAlterada?.dataInicial,
              'days',
              'init',
              -1
            ),
            dataFinal: factoryData(dataAlterada?.dataFinal, 'days', 'end', -1),
          };
          break;
        case 'WEEKLY':
          dataFiltro = {
            dataInicial: factoryData(
              dataAlterada?.dataInicial,
              'isoWeeks',
              'init',
              -1
            ),
            dataFinal: factoryData(
              dataAlterada?.dataInicial,
              'isoWeeks',
              'end',
              -1
            ),
          };

          dtAlterada = {
            dataInicial: factoryData(
              dataAlterada?.dataInicial,
              'isoWeeks',
              'init',
              -1
            ),
            dataFinal: factoryData(
              dataAlterada?.dataFinal,
              'isoWeeks',
              'end',
              -1
            ),
          };
          break;
        case 'MONTHLY':
        default:
          dataFiltro = {
            dataInicial: factoryData(
              dataAlterada?.dataInicial,
              'months',
              'init',
              -1
            ),
            dataFinal: factoryData(
              dataAlterada?.dataInicial,
              'months',
              'end',
              -1
            ),
          };

          dtAlterada = {
            dataInicial: factoryData(
              dataAlterada?.dataInicial,
              'months',
              'init',
              -1
            ),
            dataFinal: factoryData(
              dataAlterada?.dataFinal,
              'months',
              'end',
              -1
            ),
          };
          break;
      }
    } else if (order === 'future') {
      switch (tipo) {
        case 'DAILY':
          dataFiltro = {
            dataInicial: factoryData(
              dataAlterada?.dataFinal,
              'days',
              'init',
              1
            ),
            dataFinal: factoryData(dataAlterada?.dataFinal, 'days', 'end', 1),
          };

          dtAlterada = {
            dataInicial: factoryData(
              dataAlterada?.dataInicial,
              'days',
              'init',
              1
            ),
            dataFinal: factoryData(dataAlterada?.dataFinal, 'days', 'end', 1),
          };
          break;
        case 'WEEKLY':
          dataFiltro = {
            dataInicial: factoryData(
              dataAlterada?.dataFinal,
              'isoWeeks',
              'init',
              1
            ),
            dataFinal: factoryData(
              dataAlterada?.dataFinal,
              'isoWeeks',
              'end',
              1
            ),
          };

          dtAlterada = {
            dataInicial: factoryData(
              dataAlterada?.dataInicial,
              'isoWeeks',
              'init',
              1
            ),
            dataFinal: factoryData(
              dataAlterada?.dataFinal,
              'isoWeeks',
              'end',
              1
            ),
          };
          break;
        case 'MONTHLY':
        default:
          dataFiltro = {
            dataInicial: factoryData(
              dataAlterada?.dataFinal,
              'months',
              'init',
              1
            ),
            dataFinal: factoryData(dataAlterada?.dataFinal, 'months', 'end', 1),
          };

          dtAlterada = {
            dataInicial: factoryData(
              dataAlterada?.dataInicial,
              'months',
              'init',
              1
            ),
            dataFinal: factoryData(dataAlterada?.dataFinal, 'months', 'end', 1),
          };
      }
    }
    setOrder(order);
    setVerMais(true);
    setDataAlterada(dtAlterada);
    setDate(dataFiltro);
  };

  return (
    <>
      <Styles />
      <Row justify="space-between" className="rowVerMais">
        <Col xs={12} sm={12} md={12} lg={8}>
          <Button
            type="link"
            className={!disabledPassado ? 'colTextPrimario' : ''}
            onClick={() => aoVerMais('past')}
            disabled={disabledPassado}
          >
            <LeftOutlined />
            <Typography.Text>ver mais</Typography.Text>
          </Button>
        </Col>
        <Col xs={12} sm={12} md={12} lg={8} style={{ flex: 'inherit' }}>
          <Button
            type="link"
            className={!disabledFuturo ? 'colTextPrimario' : ''}
            onClick={() => aoVerMais('future')}
            disabled={disabledFuturo}
          >
            <Typography.Text>ver mais</Typography.Text>
            <RightOutlined />
          </Button>
        </Col>
      </Row>
    </>
  );
}

VerMais.propTypes = {
  tipo: PropTypes.string.isRequired,
  setDate: PropTypes.func.isRequired,
  setVerMais: PropTypes.func.isRequired,
  setOrder: PropTypes.func.isRequired,
  dataAlterada: PropTypes.instanceOf(Object).isRequired,
  setDataAlterada: PropTypes.func.isRequired,
  tab: PropTypes.string.isRequired,
};
